'use client';

import { createTRPCClient, httpBatchLink } from '@trpc/client';
import '@common/utils/serialisation/luxonDateTime';
import superjson from 'superjson';
import { AppRouter } from 'trpc/routers/_app';
import { getUrl } from './getUrl';

/**
 * A bare TRPC client without React Query integration.
 * Useful for class components or non-React usage.
 */
export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      transformer: superjson,
      url: getUrl(),
      maxURLLength: 2083, // We have to limit this, or else next doesn't let the batch through and we have to retry
    }),
  ],
});
